import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./ToggleButton.scss";

export const ToggleButton = ({ title, value, onSave }) => {
  const [isToggled, setIsToggled] = useState(value);

  useEffect(() => {
    setIsToggled(value);
  }, [value]);

  const handleToggle = () => {
    const newValue = !isToggled;
    setIsToggled(newValue);
    onSave(newValue);
  };

  return (
    <div className="toggle-container">
      <span className="toggle-title">{title}</span>
      <div
        className={`toggle-switch ${isToggled ? "toggled" : ""}`}
        onClick={handleToggle}
      >
        <div className="toggle-knob"></div>
      </div>
    </div>
  );
};

ToggleButton.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    disabled: PropTypes.bool
  };

export default ToggleButton;